import contact from './lib/contact'
import rebox from './lib/rebox'
import { toggleBelowFold, scrollSpy, smoothScroll } from './lib/scroll'

$(document).ready(function(){
  $(".read").click(function(){
    $(this).prev().toggle();
    if ($(this).text()=='Weiterlesen …') {
      $(this).text('Weniger lesen');
    }
    else {
      $(this).text('Weiterlesen …');
    }
  });
});

(function () {
  'use strict';

  window.onscroll = function() {stickyNav()};

  var navbar = document.getElementById("navbar");

  var sticky = navbar.offsetTop;

  function stickyNav() {
    if (window.pageYOffset >= sticky) {
      navbar.classList.add("sticky")
    } else {
      navbar.classList.remove("sticky");
    }
  }

  function rebox() {
    $('.lightbox-thumbs').rebox({selector: 'figure a'});
  }

  function initialize() {
    contact('#contact-form');
    rebox();
    toggleBelowFold();
    scrollSpy('.header-nav-sub:visible', {offset: 0});
    smoothScroll('a[href^="#"]', {offset: 0});
  }
  
  initialize();
})();



// WEBPACK FOOTER //
// ./Private/Scripts/application.js